import { render } from "./produtoView.vue?vue&type=template&id=3b2dd28c"
import script from "./produtoView.vue?vue&type=script&lang=js"
export * from "./produtoView.vue?vue&type=script&lang=js"

import "./produtoView.vue?vue&type=style&index=0&id=3b2dd28c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__